import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon, ChefHatIcon } from 'lucide-react';
import { PRICE, TOTAL_VALUE, DISCOUNT } from '../data/content';
import { PRODUCT_IMAGE } from '../data/productImage';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: '100% digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ChefHatIcon,
  label: 'Para cocina de casa'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: CreditCardIcon,
  label: 'Pagas en la moneda de tu país'
}];
const stats = [{
  value: '40 recetas',
  label: 'con rendimiento y costo por pieza'
}, {
  value: '6 menús',
  label: 'para reuniones de 10, 20 y 30 personas'
}, {
  value: '30 días',
  label: 'de plan para tus primeros pedidos'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-111" data-mp="3814aznapvuna">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-112" data-mp="3j89618jhw3nf">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-113" data-mp="3o7lrppymr4of">
          <div data-id="element-114" data-mp="39al9qe68qo35">
            <Reveal data-id="element-115" data-mp="39b4ip5dwy251">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-terra-dark" data-id="element-116" data-mp="399jo5frlmj76">
                Naturia Cocina · Catering para Emprender
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-117" data-mp="30hhovkt9n8yh">
                Ya cocinas rico.
                <span className="block text-mint-700" data-id="element-118" data-mp="35aax4iny0zfb">Ahora véndelo por encargo para reuniones de 10, 20 y 30 personas.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-119" data-mp="2viomanfip2d3">
                Recetas con costo por pieza, menús completos con lista de compras y cronograma, y un plan de 30 días para tomar tus primeros pedidos de bocadillos, botanas y charolas.
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-120" data-mp="s2b921mmap6q">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-121" data-mp="s3mbny4btqw9">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-sand px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-cream-line" data-id="element-122" data-mp="n9qid8z0cs7f">
                    <badge.icon className="h-4 w-4 text-terra" aria-hidden="true" data-id="element-123" data-mp="deq7wd9az01g" />
                    {badge.label}
                  </li>)}
              </ul>

              <p className="mt-8 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-124" data-mp="161b01fxlrg62">
                <span className="text-base text-ink-muted line-through" data-id="element-125" data-mp="112pz1eaj0sgk">{TOTAL_VALUE}</span>
                <span className="font-display text-3xl text-mint-700" data-id="element-126" data-mp="x14ow0pdmsa2">Hoy {PRICE}</span>
                <span className="rounded-full bg-terra-light px-2.5 py-1 text-sm font-semibold text-terra-dark" data-id="element-127" data-mp="x3h2y2s0kihu">
                  {DISCOUNT} de descuento
                </span>
              </p>

              <div className="mt-6" data-id="element-128" data-mp="3htg5fwqahzd2">
                <CtaButton data-id="element-129" data-mp="1x9ukuaytndnf">Quiero empezar a vender</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-130" data-mp="21amwtbz2vwne">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-131" data-mp="218jzs7zid396">
                    <item.icon className="h-4 w-4 text-mint-700" aria-hidden="true" data-id="element-132" data-mp="2b197qsvunyzr" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <div className="flex justify-center lg:justify-end" data-id="element-133" data-mp="2kydv2w1fm0i5">
            <img src={PRODUCT_IMAGE} alt="Portada de Catering para Emprender de Naturia Cocina, México, con charolas de tostaditas de tinga, brochetas de panela con jitomate cherry y vasitos de guacamole con totopos" className="aspect-square w-full max-w-md rounded-3xl bg-cream-deep object-cover shadow-lift" width={820} height={820} loading="eager" decoding="async" fetchPriority="high" data-id="element-134" data-mp="2l0zzwnwxu1wo" />
          </div>
        </div>

        <Reveal delay={0.05} data-id="element-135" data-mp="4bdx7gy3ybp5">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-cream-line sm:grid-cols-3" data-id="element-136" data-mp="4akwoxpqsifg">
            {stats.map(stat => <div key={stat.value} className="bg-sand px-6 py-6" data-id="element-137" data-mp="3vh5m6d05fiad">
                <dt className="font-display text-2xl text-ink" data-id="element-138" data-mp="e9tq9pgp3v1a">{stat.value}</dt>
                <dd className="mt-1 text-sm text-ink-muted" data-id="element-139" data-mp="9aqj9zh5neqo">{stat.label}</dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </header>;
}